import React from 'react';
import { Dialog, Slide, makeStyles } from '@material-ui/core';
import { func, node, bool, elementType } from 'prop-types';
import CloseButton from '../Buttons/CloseButton';

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...(props as any)} />
));

const DialogWrapper = ({ open, handleClose, children, PaperComponent, fullWidth, ...attrs }) => {
  const props = {
    ...attrs,
  };
  if (PaperComponent) props.PaperComponent = PaperComponent;
  if (fullWidth) props.fullWidth = fullWidth;

  const styles = makeStyles(({ spacing }) => ({
    paper: {
      margin: 0,
      width: '100%',
      height: `calc(100% - ${spacing(22)}px)`,
    },
    dialog: {
      '& > .MuiDialog-container': {
        alignItems: 'flex-end',
      },
      '& > .MuiButtonBase-root': {
        top: '11px',
      },
    },
  }));

  const classes = styles();

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition as any}
      PaperProps={{ className: classes.paper }}
      className={classes.dialog}
      {...props}
    >
      <CloseButton onClick={handleClose} />
      {children}
    </Dialog>
  );
};

DialogWrapper.propTypes = {
  open: bool.isRequired,
  handleClose: func.isRequired,
  children: node.isRequired,
  PaperComponent: elementType,
  fullWidth: bool,
};

DialogWrapper.defaultProps = {
  PaperComponent: null,
  fullWidth: false,
};

export default DialogWrapper;
